import { render, staticRenderFns } from "./NewslettersList.vue?vue&type=template&id=28e23370&"
import script from "./NewslettersList.vue?vue&type=script&lang=ts&"
export * from "./NewslettersList.vue?vue&type=script&lang=ts&"
import style0 from "./NewslettersList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports